<!-- 欢迎语新建，编辑 -->
<template>
  <div class="container">
    <el-dialog
      :title="this.diaTitle"
      :visible.sync="show"
      :modal-append-to-body="false"
      width="600px"
      height="400px"
      style="margin-top:5vh;"
      class="dialog-label"
      :close-on-click-modal="false"
      :before-close="cancelHandle"
    >   
      <!-- <div class="edit-tip" v-show="this.editData!=null">(编辑后已添加到活码的欢迎语也将同步修改)</div> -->
        <el-input
          type="textarea"
          clearable
          v-model="welcomeContent"
          autocomplete="off"
          size="small"
          maxlength="200"
          show-word-limit
					:rows="6"
      	></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancelHandle()" >取 消</el-button>
        <el-button type="primary" size="small" @click="confirmHandle()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { createWelcome,editWelcome } from "@/api/activeCode/activeCode.js"
export default {
  name:"WelcomeDia",
  props:["dialogVisible","diaTitle","editData"],
  data () {
    return {
        show:false,
        welcomeContent:"",
        markContent:""
    };
  },
  watch: {
    dialogVisible(val){
        this.welcomeContent = "" 
        this.markContent = ""
        this.show = val
        if(!!this.editData){
            this.welcomeContent = this.editData.welcomeContent
            this.markContent = this.editData.welcomeContent
        }
    }
  },
  methods:{
    //取消
    cancelHandle(){
      if(this.welcomeContent!=this.markContent){
        this.$confirm('', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          message:`<div style="font-size:15px;">数据尚未保存，确定取消？</div>`,
          dangerouslyUseHTMLString:true,
          iconClass:"el-icon-warning",
          customClass:"delete-messege",
          center: true
        }).then(() => {
          this.$emit("cancelHandle")
          done()
        }).catch(()=>{})
      }else{
        this.$emit("cancelHandle")
      }
    },
    //确定
    confirmHandle(){
        if(!this.welcomeContent){
            this.$message.warning('请输入欢迎语')
        }else{
            if(this.editData == null){
                //新建
                let params = {welcomeContent:this.welcomeContent}
                createWelcome(params,localStorage.getItem("Authorization")).then((res)=>{
                    if (res.error.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '创建成功!'
                        });
                        this.$emit("saveHandle")
                    }
                }).catch(err=>{})
            }else{
                //编辑
                editWelcome(
                    {
                        welcomeId:this.editData.welcomeId,
                        corpId:this.editData.corpId,
                        welcomeContent:this.welcomeContent
                    }
                    ,localStorage.getItem("Authorization")).then((res)=>{
                    if (res.error.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '编辑成功!'
                        });
                        this.$emit("saveHandle")
                    }
                }).catch(err=>{})
            }
        }
    }
  }
}

</script>
<style lang="scss" scoped>
.container{
    /deep/.el-dialog__body{
        padding: 15px 20px;
    }
    .edit-tip{
        color: #aaaaaa;
        margin-bottom: 10px;
    }
}
</style>